var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 3v4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 5h-4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 17v2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 18H3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles);
export default __webpack_public_path__ + "static/media/sparkles.a7f4c653f1767298bef891fcacbc397e.svg";
export { ForwardRef as ReactComponent };